export default "__VITE_ASSET__CrjchZsS__"